<template>
  <div>
    <h1 v-if="categories.length<=0" class="text-muted text-center">هیچ دسته‌بندی وجود ندارد</h1>
    <ul v-else class="my-5 px-2 px-md-4" style="list-style: none">
      <recursive-component v-if="breadCrumb.length > 0" :bread-crumb="breadCrumb"
                           :data-back="backward"/>
      <li v-for="item in categories.filter((x) => x.parent_id === parent_id)" class="cursor-pointer py-2 px-5"
          style="font-size: 11.5pt;" @click="parent_id = item.id; breadCrumb.push(item)">
        <img :src="item.icon" alt="" class="img-fluid" height="30" style="border: none" width="30">
        {{ item.title }}
        <v-icon color="primary" left>mdi-chevron-left</v-icon>
      </li>
    </ul>
  </div>
</template>

<script>
import Amqezi from "./recursiveComponent";
import RecursiveComponent from "./recursiveComponent";
import {Bus} from "@/main";

export default {
  name: "renderCategory",

  props: {
    value: {
      default: 0,
      type: Number
    }
  },

  components: {
    Amqezi,
    RecursiveComponent
  },

  data() {
    return {
      categories: [],
      parent_id: null,
      breadCrumb: [],
    }
  },

  mounted() {
    this.getCategory();
  },

  watch: {
    parent_id: {
      handler(value) {
        this.$emit('input', value);
        Bus.$emit('getCategoryId', value);
      },
      deep: true
    }
  },

  methods: {
    getCategory() {
      this.$api.get('/admin/category')
        .then((response) => {
          this.categories = response.data.data;
        })
    },
    backward(item) {
      const index = this.breadCrumb.indexOf(item);

      this.parent_id = item.parent_id;

      this.breadCrumb.splice(index, this.breadCrumb.length);
    },
  },
}
</script>

<style scoped>
ul > li {
  margin-top: 1rem;
  padding-right: 3rem;
  padding-block: 1rem;
  border: 1px solid rgba(0, 0, 0, .5);
  border-radius: 12px;
  list-style: none;
}
</style>